import styled from "styled-components";

export const ContainerBanner = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	justify-content: center;

	height: 100vh;
	max-height: 100vh;
	width: 30%;
	background: #00737b;

	img.background {
		position: absolute;
		width: 30%;
		height: 100%;
	}

	img.front {
		z-index: 10;
		height: auto;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		height: 40vh;
		display: flex;
		justify-content: center;

		img.background {
			width: 100%;
			height: 40%;
		}

		img.front {
			z-index: 10;
			height: auto;
		}
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	color: white;
	height: 100vh;
	max-height: 100vh;
	width: 30%;
	background: #13141b;

	@media only screen and (max-width: 768px) {
		width: 100%;
		height: 40vh;
		flex-direction: column;
		justify-content: center;
		text-align: center;
	}
`;

export const ContainerSubscribe = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	color: white;
	height: 100vh;
	max-height: 100vh;
	width: 30%;
	background: #00737b;

	@media only screen and (max-width: 768px) {
		width: 100%;
		height: 50vh;
		flex-direction: column;
		justify-content: center;
		text-align: center;
	}
`;

export const ContainerItem = styled.div`
	display: flex;
	flex-flow: column wrap;
	justify-content: center;

	@media only screen and (min-device-width: 480px) {
		padding: 20px;
	}
`;

export const AlignContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	align-self: center;
	margin: 10vh 0px;

	@media only screen and (max-width: 768px) {
		margin: 2vh 0px;
	}
`;

export const Title = styled.h2`
	font-family: "Montserrat";
	font-size: 3rem;
	font-weight: bolder;
	color: #009e9a;

	@media only screen and (max-width: 768px) {
		margin-bottom: 2vh;
		font-size: 2rem;
	}
`;

export const Subtitle = styled.span`
	font-family: "Montserrat";
	font-size: 1.3rem;
	margin-bottom: 1vh;

	@media only screen and (max-width: 768px) {
		margin-bottom: 2vh;
	}
`;

export const DivImg = styled.div`
	position: absolute;
	bottom: 0%;
	left: -15%;
	z-index: 1;
	width: 50%;

	@media only screen and (max-width: 768px) {
		top: 3%;
	}
`;

export const NewContainer = styled.div`
	display: contents;
`;
